<template>
    <div class=" font-poppins">
        <the-header></the-header>

        <!-- --------ABOUT US------------------- -->
        <div class=" flex justify-around pt-48 md:pt-32 md:flex-col ">
            <div class=" w-1/2 md:w-full">
                <p class=" text-3xl text-blue-500 font-bold md:text-2xl md:text-center">About Us</p>
                <p class=" mt-8 md:mt-4 leading-7 text-base md:p-6">
                    We are a fast-growing tech-solutions company in the Nigerian logistics sector. 
                    With a background forged from extensive experience over the years and  an
                     in-depth knowledge and understanding of the dynamics, trends, and challenges 
                     inherent in the business; we have developed an integrated model which addresses common issues and caters for all your delivery concerns as users and operators of courier services to support your business at anytime and location. We are indeed your most dependable ally in the delivery sector; 
                    providing a platform for all businesses in e-commerce to stand out strong and successful.
                </p>

                
            </div>

            <div class="w-1/3 md:w-full mt-10 md:mt-5 ">
                <img class="image w-full md:w-full md:left-0 rounded-lg " src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1644222115/carrygoWebAssets/MISSION2_hqz0q2.jpg" alt="lady1">
            </div>
        </div>

        <!-- ------------OUR HISTORY---------- -->
        <div class="mt-5  md:w-full md:ml-0 p-6 text-center bg-gray-100">
            <p class=" text-3xl text-blue-500 font-bold  md:w-full md:text-2xl  md:mb-3 ">Our History</p>
            <p class=" mt-4 leading-7  text-base ">
                CarryGo was founded by Victor Bassey and Michael Wingate on the 18th of August 2021. 
                The company identifies its services as a LogisTech -A word coined by the founders to depict 
                its innovation in creating Technological Solutions to Logistics and transport problems, provide Logistics services for door-to-door deliveries and transportation services for good and persons nationwide. CarryGo within a short time has commendably proven it's commitment to excellence and standard in the Logistics and Transport sector by rising fast to enviable prominence in providing outstanding and 
                unparalleled delivery service that exceeds user expectations but gives satisfaction.
            </p>
        </div>

        <!-- ------------OUR GUARANTEE---------- -->
        <div class="  md:w-full md:ml-0 mt-10 p-6 text-center bg-gray-100">
            <p class=" text-3xl text-blue-500 font-bold  md:w-full md:text-2xl  md:mb-3">Our Guarantee</p>
            <p class=" mt-4 leading-7  text-base ">
                We are indeed your most dependable ally in the delivery sector,  giving a platform for all businesses 
                to reach out farther and wider through e-commerce. 
                A platform to  stand out, to be strong and to be successful.
            </p>
        </div>

        <!-- ------------OUR Values---------- -->
        <div class="  md:w-full md:ml-0 mt-10 p-6 text-center bg-gray-100">
            <p class=" text-3xl text-blue-500 font-bold  md:w-full md:text-2xl  md:mb-3">Our Values</p>
            <p class=" mt-4 leading-7  text-base ">
               Healthy client relationships are our priority - meeting their 
               needs and expectations form the basis of our strategy for every service we render. 
               We are set up to deliver for our clients, wherever they are and whatever the size.
            </p>
        </div>


<!-- --------------------VISION AND MISSION----------------- -->
        <div class=" flex justify-around mt-40 md:flex-col md:pr-2 md:pl-2 ">
            <div class="w-1/2 md:w-full">
                <img class="  md:w-full md:left-0 rounded-lg" src="./Images/carrygo-support.jpg" alt="lady1">
            </div>

            <div class=" w-1/2 ml-20 md:w-full md:ml-0 ">
                <p class=" mt-10 text-3xl text-blue-500 font-bold w-1/2 md:w-full md:text-2xl md:text-center  md:mb-3">Our Mission</p>
                <p class=" mt-4 leading-7  text-base p-4 md:text-center">
                    Supporting society and sustaining humanity; place to place, door to door.
                </p>

                <div class="mt-10">
                    <p class=" text-3xl text-blue-500 font-bold w-1/2 md:w-full md:text-2xl md:text-center md:mb-3">Our Vision</p>
                    <p class=" mt-4 leading-7  text-base p-4 md:text-center">
                        Redesigning logistics from the traditional service  into a digital idea; creating a global community of limitless opportunities, where goods may be supplied; also value, 
                        culture, and other systems that enhance globalisation through technology.
                    </p>
                </div>
            </div>

        </div>

        <!-- -----------STATS AND FIGURES -------------------- -->
        <div class=" mt-40 md:mt-20 pb-20 md:pb-6">
            <div>
                <p class=" font-semibold text-blue-700 text-center text-3xl md:text-xl">Stats and figures that tells our story</p>
            </div>

            <div class=" flex justify-center mt-10 md:flex-col">
                <div class=" w-1/3 bg-gray-300 pt-10 pb-10 md:w-full">
                    <div class=" w-1/2 m-auto text-center">
                        <img class=" w-16 h-16 m-auto" src="./Images/blue-circle.png" alt="blue-circle">
                        <p class=" mt-5 font-semibold">{{downloads}} Downloads</p>
                    </div>
                </div>

                <div class=" w-1/3 bg-gray-300 ml-4 pt-10 pb-10 md:w-full md:mt-5 md:ml-0">
                    <div class=" w-1/2 m-auto text-center">
                        <img class=" w-16 h-16 m-auto" src="./Images/blue-circle.png" alt="blue-circle">
                        <p class=" font-semibold  mt-5">Over {{users}} existing users</p>
                    </div>
                </div>

                <div class=" w-1/3 bg-gray-300 ml-4 pt-10 pb-10 md:w-full md:mt-5 md:ml-0">
                    <div class=" w-1/2 m-auto text-center">
                        <img class=" w-16 h-16 m-auto" src="./Images/blue-circle.png" alt="">
                        <p class=" font-semibold mt-5">Across States in Nigeria</p>
                    </div>
                </div>

                

                <div class=" w-1/3 bg-gray-300 ml-4 pt-10 pb-10 md:w-full md:mt-5 md:ml-0">
                    <div class=" w-1/2 m-auto text-center">
                        <img class=" w-16 h-16 m-auto" src="./Images/blue-circle.png" alt="">
                        <p class=" font-semibold   mt-5">{{orders}} Deliveries in less than 2 months</p>
                    </div>
                </div>
            </div>
        </div>

        <the-footer></the-footer>
    </div>
</template>

<style scoped>
.image {
    height: 30rem;
    object-fit: cover;
}
@media (max-width: "540px") {
    .image {
        object-fit: contain;
    }
}
</style>

<script>
import axios from 'axios';
import {baseUrl} from '../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            downloads : "",
            users: "",
            orders:""
        }
    },

    mounted() {
        this.getDownloads();
        this.getUsers();
        this.getOrders();
    },

    methods: {
        getDownloads() {
            axios({
                method: "GET",
                url: `${url}/v1/web/extras/downloads`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((res) => {
                this.downloads = res.data.data.googleAppMeta.installs
            })

        },

        getUsers() {
            axios({
                method: "GET",
                url: `${url}/v1/web/users`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((res) => {
                this.users = res.data.data.totalResults
            })
        },
        getOrders() {
            axios({
                method: "GET",
                url: `${url}/v1/web/orders`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((res) => {
                this.orders = res.data.data.totalResults
            })
        }
    }
}
</script>